module.exports = __webpack_public_path__ + "static/img/product1.f88f3e17.png";